var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { FixedSizeList, VariableSizeList } from "react-window";
import { webkitVisibleScrollbar } from "../../../../mixins";
export var StyledFixedList = styled(FixedSizeList)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), webkitVisibleScrollbar);
export var StyledVariableList = styled(VariableSizeList)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), webkitVisibleScrollbar);
var templateObject_1, templateObject_2;
